module.exports = __webpack_public_path__ + "static/media/legenda.ec673a52.png";